import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Card, CardHeader, CardContent, CardFooter } from '@/components/ui/card'
import { Separator } from 'radix-vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'TopicSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "overflow-hidden animate-pulse border-gray-800" }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardHeader), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "flex items-center space-x-4" }, [
            _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-zinc-700" }),
            _createElementVNode("div", { class: "space-y-2" }, [
              _createElementVNode("div", { class: "w-24 h-4 bg-zinc-700 rounded" }),
              _createElementVNode("div", { class: "w-16 h-3 bg-zinc-700/50 rounded" })
            ])
          ], -1)
        ])),
        _: 1
      }),
      _createVNode(_unref(CardContent), null, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "space-y-2" }, [
            _createElementVNode("div", { class: "w-full h-4 bg-zinc-700 rounded" }),
            _createElementVNode("div", { class: "w-full h-4 bg-zinc-700 rounded" }),
            _createElementVNode("div", { class: "w-2/3 h-4 bg-zinc-700 rounded" })
          ], -1)
        ])),
        _: 1
      }),
      _createVNode(_unref(CardFooter), { class: "flex flex-col space-y-2" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Separator), { class: "bg-gray-800" }),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex justify-between w-full py-2" }, [
            _createElementVNode("div", { class: "w-20 h-8 bg-zinc-700 rounded mx-4" }),
            _createElementVNode("div", { class: "w-20 h-8 bg-zinc-700 rounded mx-4" })
          ], -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})